import { render, staticRenderFns } from "./OthersFeatures.vue?vue&type=template&id=82b3fa68"
import script from "./OthersFeatures.vue?vue&type=script&lang=js"
export * from "./OthersFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports